import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import block from 'bem-cn'

import { ROUTE_URLS } from 'router/routes'

import { ReactComponent as PromotionsIcon } from 'shared/img/promotions.svg'

import { BonusPromotionStatus } from 'shared/models/Promotion'

import { selectBonusPromotionsPolling } from 'features/bonusSystem/selectors'

import './PromotionsButton.scss'

const b = block('promotions-button')

const activeStatuses = [BonusPromotionStatus.available, BonusPromotionStatus.available_completed]

export function PromotionsButton() {
  const history = useHistory()
  const promotions = useSelector(selectBonusPromotionsPolling, shallowEqual)

  const count = promotions.filter(p => activeStatuses.includes(p.status)).length

  const handleClick = () => {
    history.push(`${ROUTE_URLS.MAIN()}?openedModals=%2Fpromotions&status=${BonusPromotionStatus.available}`)
  }

  return (
    <button className={b()} onClick={handleClick}>
      <PromotionsIcon />
      {count > 0 && <span className={b('count')}>{count}</span>}
    </button>
  )
}
